import { of } from 'rxjs';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../app.state';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as actions from './actions';
import { MatchesService } from '../../services/matches.service';
import { AlertService } from '../../services/alert.service';
import { switchMap, catchError, map } from 'rxjs/operators';

@Injectable()
export class MatchesEffects {
  constructor(
    protected store: Store<AppState>,
    protected service: MatchesService,
    protected action$: Actions,
    private errorService: AlertService
  ) { }

  GetAllMatches$ = createEffect(() => this.action$.pipe(
    ofType<actions.GetMatchesListAction>(actions.GET_MATCHES_LIST),
    switchMap(action => this.service.getAllMatches().pipe(
      map((result) => new actions.GetMatchesListActionSuccess(result)),
      catchError(error => {
        this.errorService.error(error);
        return of(new actions.GetMatchesListActionError(error));
      })))));

  UpdateMatch$ = createEffect(() => this.action$.pipe(
    ofType<actions.UpdateMatchAction>(actions.UPDATE_MATCH),
    switchMap(action =>
      this.service.updateMatch(action.item).pipe(
        map(result => new actions.UpdateMatchSuccessAction()),
        catchError(error => {
          this.errorService.error(error);
          return of(new actions.UpdateMatchErrorAction(error));
        })))
  ));
}
